export const defaultGrid = {
  columnWidth: 88,
  rowHeight: 24,
  topHeaderHeight: 20,
  leftHeaderWidth: 46,
  bottomFooterHeight: 36
};